import { IApiBaseProps } from '@common/api.models';

export interface IProjectMasterScheduleTagBase {
  id?: number;
  projectMasterScheduleId: number;
  tagTypeId: number;
  name: string;
  rowVersion?: string;
}

export interface IProjectMasterScheduleTag extends IProjectMasterScheduleTagBase {
  tagTypeName?: string;
}

export interface IProjectMasterScheduleTagsSearchRequest extends IApiBaseProps {
  text?: string;
}

export interface IDeleteProjectMasterScheduleTagRequest extends IApiBaseProps {
  name: string;
  tagTypeId: number;
}
export interface IUpdateProjectMasterScheduleTagRequest extends IApiBaseProps {
  newName: string;
  originalName: string;
  tagTypeId: number;
}

export enum ETagManageFormKey {
  NEW_NAME = 'newName',
  ORIGINAL_NAME = 'originalName',
  TAG_TYPE_ID = 'tagTypeId',
}

export interface ITagManageFormState {
  [ETagManageFormKey.NEW_NAME]: string | null;
  [ETagManageFormKey.ORIGINAL_NAME]: string | null;
  [ETagManageFormKey.TAG_TYPE_ID]: number;
}
